import { getUrlParams } from './get-url-params';

export function buildFbp(): string {
  const creationTime = Date.now();
  const randomNumber = Math.floor(Math.random() * 1e16); // 16 dígitos
  return `fb.1.${creationTime}.${randomNumber}`;
}

export function buildFbc(): string | null {
  const fbclid = getUrlParams('fbclid');
  if (!fbclid) return null;
  const creationTime = Date.now();
  return `fb.1.${creationTime}.${fbclid}`;
}
